import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

export const FormWrapper = styled.form`
  width: 550px;
  padding: 0 16px;

  @media(min-width: 480px) {
    padding: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 18px;
`;

export const Error = styled.div`
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.ERROR_RED};
`;
